import React from "react"
import { Link } from "gatsby"

const OurHistory = () => {
  return (
    <>
      <section id="company" className="history-area pt-50">
        <div className="container">
          <div className="section-title3">
          <h3>About Us</h3>
          </div>
            <div class="content-box2">
              <p>Evrchat was founded with a mission to enable MSPs boost service delivery and business performance with a purpose-built Platform. <br />
Our team has a track record of success in several ICT product development projects internationally. </p> <br />
            </div>
          <div className="section-title3">
            <h3>Roadmap</h3>
          </div>
            <div class="content-box2">
              <p> We are excited to announce the integration of PSA, to deliver more values and benefits to MSPs and their customers. </p>
              <br />
            </div>
        </div>
      </section>
    </>
  )
}

export default OurHistory
